app.controller('homeController', ['$scope', '$state', '$mdToast', '$mdDialog', 'objectHelper', 'applicationModel', 'userModel', 'visitModel', 'visitCardModel',
    function ($scope, $state, $mdToast, $mdDialog, objectHelper, applicationModel, userModel, visitModel, visitCardModel) {

        var today = new Date();
        today.setHours(0,0,0,0);

        var tommorow = new Date();
        tommorow.setDate(tommorow.getDate() + 1);
        tommorow.setHours(0,0,0,0);

        var selectedDate = today;


        function checkStatuses(array) {
            return array.some(function(element) {
                return element.visitStatus === Enum.VISIT_STATUS.SUSPENDED || element.visitStatus === Enum.VISIT_STATUS.IN_PROGRESS;
            })
        }

        function setData() {
            $scope.isTodaySelected = true;
            $scope.isTommorowSelected = false;
            $scope.clinicsWithVisits = [];

            $scope.statuses = Object.keys(Enum.VISIT_STATUS);
            $scope.statuses.unshift('NO_FILTER');
            $scope.selectedStatus = 'NO_FILTER';
            $scope.showButtonForVisitsToFill = false;

            /**
             * @author Karol Tatała
             * fixme - I tried to avoid so many watchers by this. It helps but the idea is quite difficult.
             * I would change it to normal watcher in future
             //
             */
            Object.defineProperty($scope, 'selectedDate', {
                enumerable: true,
                configurable: false,
                get: function () {
                    return selectedDate;
                },
                set: function (val) {
                    selectedDate = val;
                    if(selectedDate) {
                        selectedDate.setHours(0,0,0,0);
                        if(selectedDate.getTime() === today.getTime()) {
                            $scope.isTodaySelected = true;
                        } else {
                            $scope.isTodaySelected = false;
                        }
                        if(selectedDate.getTime() === tommorow.getTime()) {
                            $scope.isTommorowSelected = true;
                        } else {
                            $scope.isTommorowSelected = false;
                        }
                        var criteria = new VisitDataGridCriteria();
                        criteria.dateFrom = selectedDate;
                        criteria.dateTo = angular.copy(selectedDate);
                        criteria.dateTo.setDate(selectedDate.getDate() + 1);
                        criteria.doctorId = userModel.getCurrentContextDoctorId();

                        if($scope.selectedStatus != 'NO_FILTER') {
                            criteria.visitStatus = $scope.selectedStatus;
                        }

                        visitModel.getDataPage(criteria);
                    }
                }
            });

        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on('$destroy', function (event) {
                applicationModel.viewReady = false;
            });

            $scope.$watch('selectedStatus', function (newVal) {
                var criteria = new VisitDataGridCriteria();
                criteria.dateFrom = selectedDate;
                criteria.dateTo = angular.copy(selectedDate);
                criteria.dateTo.setDate(selectedDate.getDate() + 1);
                criteria.doctorId = userModel.getCurrentContextDoctorId();

                if(newVal != 'NO_FILTER') {
                    criteria.visitStatus = newVal;
                }

                visitModel.getDataPage(criteria);
            });

            $scope.$on(Event.VISIT.GET_DATA_PAGE.SUCCESS, function (event, dataPage) {
                $scope.visits = dataPage.data;
                $scope.clinicsWithVisits = [];
                $scope.visits.forEach(function (visit, index) {
                    if(!$scope.clinicsWithVisits.length) {
                        var clinicWithVisit = {
                            clinic: visit.clinic,
                            visits: [visit]
                        };
                        $scope.clinicsWithVisits.push(clinicWithVisit);
                    } else {
                        if($scope.clinicsWithVisits[$scope.clinicsWithVisits.length-1].clinic.id === visit.clinic.id) {
                            $scope.clinicsWithVisits[$scope.clinicsWithVisits.length-1].visits.push(visit);
                        } else {
                            var clinicWithVisit = {
                                clinic: visit.clinic,
                                visits: [visit]
                            };
                            $scope.clinicsWithVisits.push(clinicWithVisit);
                        }
                    }
                });
            });

            $scope.$on(Event.VISIT.CANCEL.SUCCESS, function (event, visitCard) {
                var criteria = new VisitDataGridCriteria();
                criteria.dateFrom = selectedDate;
                criteria.dateTo = angular.copy(selectedDate);
                criteria.dateTo.setDate(selectedDate.getDate() + 1);
                criteria.doctorId = userModel.getCurrentContextDoctorId();
                visitModel.getDataPage(criteria);
            });

            $scope.$on(Event.VISIT.CHECK_FOR_VISITS_TO_FILL.SUCCESS, function(event, dataPage) {
                if(dataPage.data.length) {
                    $scope.showButtonForVisitsToFill = true;
                }
            })
        }

        function setActions() {
            $scope.setToday = function () {
                $scope.selectedDate = today;
            };

            $scope.setTommorow = function () {
                $scope.selectedDate = tommorow;
            };

            $scope.viewVisitCard = function (visit) {
                $state.go(Constant.STATE.APP.PATIENT.VIEW.VISIT_CARD_VIEW, { patientId: visit.patient.id, visitId: visit.id });
            };

            $scope.fillVisitCard = function (visit) {
                if((visit.visitStatus === Enum.VISIT_STATUS.IN_PROGRESS || visit.visitStatus === Enum.VISIT_STATUS.PLANNED) && $scope.isTodaySelected) {
                    $state.go(Constant.STATE.APP.PATIENT.VIEW.VISIT_CARD, { patientId: visit.patient.id, visitId: visit.id });
                } else {
                    $mdToast.show(
                        $mdToast.simple({
                            content: $translate.instant('T.MODULE.VISIT.CANNOT_OPEN_VISIT_CARD_FOR_THIS_VISIT'),
                            hideDelay: 1500,
                            position: 'top right'
                        })
                    );
                }
            };

            $scope.addVisit = function () {
                $state.go(Constant.STATE.APP.VISIT.CREATE);
            };

            $scope.downloadPDF = function (visit) {
                visitCardModel.downloadPDF(visit.visitCard.id);
            };

            $scope.showVisitDetails = function (visit) {
                if(!visit.firstForPatientDoctor || visit.visitStatus != Enum.VISIT_STATUS.PLANNED) {
                    $mdDialog.show({
                        templateUrl: 'edm/application/view/app/patient/popup/popup-visit-details.html',
                        controller: 'popupVisitDetailsController',
                        resolve: {
                            visit: function () {
                                return visit;
                            }
                        },
                        skipHide: true // this is a hack for not closing modals problem
                    });
                }
                if(visit.firstForPatientDoctor && visit.visitStatus === Enum.VISIT_STATUS.PLANNED) {
                    $mdDialog.show({
                        templateUrl: 'edm/application/view/app/patient/popup/popup-patient-first-visit.html',
                        controller: 'popupVisitDetailsController',
                        resolve: {
                            visit: function () {
                                return visit;
                            }
                        },
                        skipHide: true // this is a hack for not closing modals problem
                    });
                }
            };

            $scope.goToFillingVisitsData = function() {
                $state.go(Constant.STATE.APP.FILL_DATA);
            };

            $scope.checkForVisitsToComplete = function(array) {
                if(checkStatuses(array) && !$scope.showButtonForVisitsToFill) {
                    $scope.showButtonForVisitsToFill = true;
                }
            };
        }

        function configureInterface() {
            applicationModel.selectMenuItemWithState(Constant.STATE.APP.HOME);

            var breadcrumbItems = [];
            applicationModel.setBreadcrumbItems(breadcrumbItems);
            applicationModel.setTitleBar('T.UI.APPLICATION.HOME_PAGE');
        }

        function initialize() {
            applicationModel.viewReady = true;
            applicationModel.fillViewportMode = true;

            var criteria = new VisitDataGridCriteria();
            criteria.doctorId = userModel.getCurrentContextDoctorId();
            criteria.visitStatuses = [Enum.VISIT_STATUS.SUSPENDED, Enum.VISIT_STATUS.IN_PROGRESS];
            criteria.rowsPerSheet = 5;

            visitModel.checkForVisitsToFill(criteria);
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
